export const SEARCHING = 'SEARCHING';
export const SEARCHING_WAIT = 'SEARCHING_WAIT';

export const SAVE_RATES = 'SAVE_RATES';
// export const SAVE_RATES_FAILED = 'SAVE_RATES_FAILED';

export const SAVE_LIMITED_RATES = 'SAVE_LIMITED_RATES';

export const ADD_NATION = 'ADD_NATION';
export const DELETE_NATION = 'DELETE_NATION';

export const SAVE_BASE_CURRENCY = 'SAVE_BASE_CURRENCY';

export const SAVE_FIRST_CURRENCY = 'SAVE_FIRST_CURRENCY';
export const SAVE_SECOND_CURRENCY = 'SAVE_SECOND_CURRENCY';

export const GET_RANGED_DATES = 'GET_RANGED_DATES';

export const SAVE_CONVERT_AMOUNT = 'SAVE_CONVERT_AMOUNT';

export const SAVE_DATES = 'SAVE_DATES';
// export const SAVE_END_DATE = 'SAVE_END_DATE';